<div class="mobile-sort-button" (click)="onClickMobileSortButton()">
  <i class="icon-filter"></i>
  {{currentFilter | translate}}
  <i class="icon-chevron-down"></i>
</div>

<p-dialog position="bottom" [(visible)]="openSortDialog" [dismissableMask]="true" [baseZIndex]="10000" [modal]="false"
  [closable]='true' *ngIf="openSortDialog" styleClass="fullScreen-dialog fullScreenWithBlack-dialog sort-dialog">
  <div class="sort-dialog-container">
    <div class="sort-title">
      <i class="icon-filter"></i>
      {{"label.sort.by" | translate}}
      <i class="icon-times" (click)="openSortDialog = false"></i>
    </div>

    <ng-template ngFor let-item [ngForOf]="sortList" let-i="index">
      <app-button [textButton]="true" [buttonName]="item.label" (onClickEvent)="onSorting(item, i)"
        [ngClass]="{'active': item.active}" class="sort-btn"></app-button>
    </ng-template>
  </div>
</p-dialog>
